export default {
  /**
   * Quốc gia
   */
  Nation: 0,
  /**
   * Tỉnh thành
   */
  Province: 1,
  /**
   * Quận huyện
   */
  District: 2,
  /**
   * Xã phường
   */
  Ward: 3,
}
